<template>
    <div class="feature-app-showcase section-space--pb_90">
        <div class="container_fl">
            <div class="row align-items-center">
                <div class="col-lg-6">
                    <div class="app-showcase-image__media wow move-up">
                        <img :src="thumbnail" class="img-fluid" alt="thumbnail">
                    </div>
                </div>
                <div class="col-lg-6">
                    <div class="app-showcase__content">
                        <div class="app-showcase__inner">
                            <h4 class="font-weight--light wow move-up">{{ title }}</h4>
                            <div class="sub-text section-space--mb_40 wow move-up">{{ desc }}</div>
                            <h6 class="sub-heading  wow move-up">Store your patients' data easily, and safely online.<a href="mailto:roberto.baldizon@silibrain.com"> Reach out to learn more.</a>
                            </h6>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default{
        name: 'Download',
        data (){
            return {
                thumbnail: require("../assets/img/banners/aeroland-app-showcase-image-02.png"),
                title: 'Keep Medical Records Online',
                desc: 'Utilise MD-Anonymous to create forms tailored to your needs to save and view data as desired, or upload all the files like images or pdfs to easily access through the internet with existing mobile and desktop devices.',
            }
        }
    };
</script>

<style lang="scss">

</style>